export const SETTLEMENT_SHOW_RESET = 'SETTLEMENT_SHOW_RESET'
export const SETTLEMENT_SHOW_SET_ERROR = 'SETTLEMENT_SHOW_SET_ERROR'
export const SETTLEMENT_SHOW_SET_RETRIEVED = 'SETTLEMENT_SHOW_SET_RETRIEVED'
export const SETTLEMENT_SHOW_TOGGLE_LOADING = 'SETTLEMENT_SHOW_TOGGLE_LOADING'
